import * as React from 'react'
import PropTypes from "prop-types";
import {PurtyNumber} from "./PurtyNumber";
import "./metricDelta.scss";
export class MetricDelta extends React.Component {

  static propTypes = {
    currentValue: PropTypes.number,
    delta: PropTypes.number,
    decimalDelta: PropTypes.number,
    negativeIsGood: PropTypes.bool,
    showDeltaWithColor: PropTypes.bool,
    showIcon: PropTypes.bool,
    percent: PropTypes.bool,
    ...PurtyNumber.propTypes
  };

  static defaultProps = {
    showIcon: true,
    showDeltaWithColor: false,
    negativeIsGood: false,
    percent: true,
  };


  render() {
    // Negative Is Good, indicates that a negative trend is a positive thing.
    // flushLeft indicates no left spacing should be applied to the number
    // largeText indicates larget font size for inline deltas
    const {
      currentValue, 
      delta, 
      decimalDelta, 
      negativeIsGood, 
      showDeltaWithColor, 
      showIcon,
      flushLeft,
      largeText,
      percent,
      largeFormat
    } = this.props;
    /*Ratio is calculated from currentValue and delta unless provided*/

    let deltaText = null
    let ratio = decimalDelta || null
    let absRatio = null

    if (!ratio && delta && delta !== undefined) {
      ratio = delta / (currentValue - delta)
      if (ratio === Infinity || ratio === -Infinity) {
        ratio = null
      }
    }

    let iconClass = ' '

    // To ensure the trend direction is good
    let shouldCorrectTrend = negativeIsGood ? ratio < 0 : false;
    let colorClass = ' '
    if (ratio < 0) {
      colorClass += shouldCorrectTrend ? 'sentiment positive' : 'sentiment negative'
      if (showIcon) iconClass += 'fa-arrow-down'
    }
    else if (ratio > 0) {
      colorClass += shouldCorrectTrend ? 'sentiment negative' : 'sentiment positive'
      if (showIcon) iconClass += 'fa-arrow-up'
    }

    return (
      <React.Fragment>
        {
          Math.abs(ratio) > 0 ?
          (<div className={`${showDeltaWithColor ? colorClass : ""} ${!flushLeft ? "content-spacer-left" : ""} ${largeText ? "" : "text-small"}`}>
             <PurtyNumber
                largeFormat={largeFormat}
                classSelector={() => "d-flex flex-row align-items-center"}
                colorClass={showDeltaWithColor ? colorClass : ""}
                suffix={() => <div className={`far ${iconClass}`} style={{marginLeft: '2px'}}></div>}
                value={ratio}
                percent={percent}
                {...this.props}
              />
          </div>)
          :
          null
        }
      </React.Fragment>)
  }
}